jQuery(document).ready(function() {
// initialize api.
    var base_url = "https://ticketco.events:443";
    var ticketco_token = "mZzUD-xnweRJ-Vu9m2Ba";
    var ticketco_status = "active";
    var api_events = base_url + "/api/public/v1/events?token=" + ticketco_token + "&status=" + ticketco_status;
    jQuery.ajax({
        url: api_events,
        type: "get",
        dataType: "json",
        success: function(response) {
// console.log(response);
        var content = "";
        if (!jQuery.trim(response) || jQuery.trim(response) == null || jQuery.trim(response) == undefined) {
            content += "<div class='empty-val'><p><strong>No results found.</strong></p></div>";
        } else {
            jQuery.each(response.events, function(key, value) {
            //console.log(value);
            var match_full_date = new Date(value?.start_at).toDateString();
            var match_date = new Date(value?.start_at).toLocaleDateString('en-GB');
            var match_time = new Date(value?.start_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
            var venue =  value?.location_name;
            var ticketco_link = value?.desktop_link;
            content += "<div class='card-container-ticketco'>";
            content += "<img src='"+ value?.image.url +"' alt='"+ value?.title +"'>";
            content += "<div class='ticketco-match-info'>";
            content += "<h4>"+ value?.title +"</h4>";
            content += "<p>"+ match_full_date + "&nbsp;"+ match_time +"</p>";
            content += "<p>"+ venue +"</p>";
            content += "<div class='ticket-btn'><a>Buy Ticket</a></div>";
            content += "<a href='"+ ticketco_link +"' target='_blank'></a>";
            content += "</div>";
            content += "</div>";
            });
        }
// insert content.
        jQuery('.card-ticketco').html(content);
        },
        error: function(errorThrown) {
        console.log(errorThrown);
        }
    });
});